import { Text, ToggleButtonGroup, VStack, makeUclComponent } from '@rbilabs/universal-components';

import { getDesignToken } from 'styles/constants';
export const StyledDonationCard = VStack.withConfig({
  rounded: 'md',
  backgroundColor: getDesignToken('background-card'),
  padding: '$4',
});

export const StyledDonationTitle = Text.withConfig({
  variant: 'headerThree',
  marginBottom: '$0',
});

export const StyledDonationSubTitle = Text.withConfig({
  variant: 'copyTwo',
  fontSize: 'sm',
});

export const StyledToggleButtonGroup = makeUclComponent(ToggleButtonGroup).withConfig({
  marginTop: '$4',
});
